import {
  Box,
  Button,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

import AddIcon from "@mui/icons-material/Add";
import { useState } from "react";

import React from "react";
import SearchBar from "../../components/SearchBar";
import SwitchToggle from "../../components/SwitchToggle";
import AddTopping from "../../Modals/addtopping";


const ManageToppings = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };
  const [rows] = useState([
    {
      id: 1,
      name: "Chocolate Chips",
      Quantity: '3 pieces',
      Limit: "5",
      createdDate: "01-Sept-2025",
      status: true,
    },
    {
      id: 2,
      name: "Kiwi",
      Quantity: '3 pieces',
      Limit: "5",
      createdDate: "03-Sept-2025",
      status: false,
    },
    {
      id: 3,
      name: "Blackberries",
      Quantity: '3 pieces',
      Limit: "5",
      createdDate: "05-Sept-2025",
      status: true,
    },
  ]);

  return (
    <>
      <div className="main_title">
        <h1>Manage Toppings</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Manage Toppings
        </p>
      </div>

      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={searchTerm}
              setDebouncedSearchTerm={setSearchTerm}
              placeholder="Search..."
            />
          </div>
          <div className="right_s">
            <Button
              className="btn btn_primary"
              onClick={() => setOpenModal(true)}
            >
              <AddIcon /> Add Topping
            </Button>
          </div>
        </div>

        <TableContainer className="table_container">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Sr. No</TableCell>
                <TableCell>Topping</TableCell>
                <TableCell>Topping Slice</TableCell>
                <TableCell>Quantity</TableCell>
                <TableCell>Max Limit</TableCell>
                <TableCell>Created Date</TableCell>
                <TableCell>Restrict Redemption</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {rows.map((row, index) => (
                <TableRow hover key={row.id}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>
                    <Box component="a" className="user_block"
                    >
                      <figure>
                        <img src="/static/images/placeholder.png" alt="User" />
                      </figure>
                      <p>
                        <b>{row.name}</b>
                      </p></Box>
                  </TableCell>
                  <TableCell>
                    <Box component="a" className="user_block"
                    >
                      <figure>
                        <img src="/static/images/placeholder.png" alt="User" />
                      </figure>
                    </Box>
                  </TableCell>

                  <TableCell>{row.Quantity}</TableCell>
                  <TableCell>{row.Limit}</TableCell>
                  <TableCell>{row.createdDate}</TableCell>
                  <TableCell>
                    <SwitchToggle />
                  </TableCell>
                  <TableCell>
                    <SwitchToggle />
                  </TableCell>
                  <TableCell>
                    <div className="table_actions v2">

                      <IconButton
                        onClick={() => setOpenModal(true)}
                      >
                        <img src="/static/images/edit2_icon.svg" alt="Edit" />
                      </IconButton>
                      <IconButton>
                        <img src="/static/images/trash2_icon.svg" alt="Delete" />
                      </IconButton>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div >

      <AddTopping
        open={openModal}
        onClose={handleCloseModal}
        setOpen={setOpenModal}
      />
    </>
  );
};

export default ManageToppings;
